<div class="main-content">
    <div class="container-fluid">
        <div style="float: right; margin-right: 20px" class="row">
            
        </div>
        <div class="clearfix"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card/-header-primary card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">people</i>
                        </div>
                        <h4 class="card-title"> Representatives </h4>
                    </div>
<!--                     <div class="card-header card/-header-primary card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">people</i>
                        </div>
                        <h4 class="card-title">Staff</h4>
                    </div> -->
                    <div class="card-body">
                        <div class="toolbar">
                            <div class="row">
                                <div class="col-md-12" >
                                    <section class="toolbar-container">
                                        <div   class="toolbar-button-container pt-1">
                                            <div class="col-lg-12 col-sm-12 button-select-container">
            
                                                <app-button-select 
                                                [options]="optionsButtonSelect" 
                                                [(selected)]="optionSelectMenuTrigger"
                                                (selectedChange)="menuTriggerToShow($event)"
                                                [label]="'Status'"
                                                [widthPx]="138"
                                                [specialWidth]="224"
                                                >
                                              </app-button-select>
                                            
                                            </div>
                                         </div>
                                        <div class="toolbar-button-container pr-1 pt-1 ">
                          
                                         <div class="col-lg-12 col-sm-12 col-md-12 button-container">
                                             <button *ngIf="guard.permissions('addrepresentative')" (click)="openNuevoPaciente()" matRipple class="gts-btn-primary w-100 btnWidth">
                                                  <span class="gts-btn-icon-left">add</span><span class="gts-btn-text">Representative</span>
                                             </button>
                                         </div>
                                
                            
                       
                                        </div>
                                    </section>
                                    <!--   &nbsp;&nbsp; -->
                      
<!--                                     <button type="button" class="btn btn-outline-{{activos === 1 ? 'info' : 'danger'}}" (click)="cambiarActivos()">
                                      <i class="fa fa-eye" aria-hidden="true"></i> Show {{activos === 1 ? 'Inactive' : 'Active'}} Staff
                                    </button> -->
                                <!-- </div> -->
                              </div>
                        </div>

                        <div *ngIf="cargando" style="text-align: center">
                            <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
                        </div>

                        <dinamic-table
                            *ngIf="!cargando"
                            [id]="'staffTable'"
                            [frontpaginate]="false"
                            [data]="staffData"
                            [config]="config"
                            (action_button)="actions($event)"
                            (newConfig)="updateConfig($event)"
                            [columnfilters]="filtros"
                            (buscar)="getData($event)"
                            [perPage]="pageLimit"
                            [page]="page"
                            [total_items_count]="totalItems"
                            [total_pages]="totalPaginas"
                        ></dinamic-table>
                    </div>
                    <!-- end content-->
                </div>
                <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
        </div>
        <!-- end row -->
    </div>
</div>